const getters = {
  userInfo: (state) => state.login.userInfo,
  userbalance: (state) => state.user.userbalance,
  userExtInfo: (state) => state.login.userExtInfo,
  userLimit: (state) => state.login.userLimit,
};
export default getters;
